import React, { createContext, ReactNode, useContext } from 'react';

const AnalyticsContainerContext = createContext(false);
type TAnalyticsContainer = { state?: any; children: ReactNode };

const useAnalyticsContainer = () => {
  const context = useContext(AnalyticsContainerContext);

  if (context === undefined) {
    throw new Error(
      'useAnalyticsContainer must be used within a AnalyticsContainerContext.Provider'
    );
  }
  return context;
};

const AnalyticsContainer = ({ children }: TAnalyticsContainer) => {
  return (
    <AnalyticsContainerContext.Provider value={true}>
      {children}
    </AnalyticsContainerContext.Provider>
  );
};

export { AnalyticsContainer, useAnalyticsContainer };
